import React, { useEffect, useState, useRef } from 'react';
import { BoxIcon } from 'lucide-react';
interface StatCardProps {
  icon?: BoxIcon;
  number: string;
  label: string;
  description: string;
}
export function StatCard({
  icon: Icon,
  number,
  label,
  description
}: StatCardProps) {
  const [isVisible, setIsVisible] = useState(false);
  const [count, setCount] = useState(0);
  const cardRef = useRef<HTMLDivElement>(null);
  // Extract numeric value from number string
  const targetNumber = parseInt(number.replace(/[^0-9]/g, '')) || 0;
  const suffix = number.replace(/[0-9]/g, '');
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.3
    });
    if (cardRef.current) {
      observer.observe(cardRef.current);
    }
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    const duration = 2000;
    const steps = 60;
    const increment = targetNumber / steps;
    let current = 0;
    const timer = setInterval(() => {
      current += increment;
      if (current >= targetNumber) {
        setCount(targetNumber);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, duration / steps);
    return () => clearInterval(timer);
  }, [isVisible, targetNumber]);
  return <div ref={cardRef} className="bg-white p-8 rounded-card border border-neutral-200 shadow-corporate card-hover text-center" data-id="element-285">
      {Icon && <div className="mx-auto mb-6 w-14 h-14 rounded-lg bg-red-50 flex items-center justify-center text-primary" data-id="element-286">
          <Icon className="w-7 h-7" strokeWidth={2} data-id="element-287" />
        </div>}

      <div className="text-5xl font-heading font-bold text-dark mb-2" data-id="element-288">
        {isVisible ? count : 0}
        {suffix}
      </div>

      <div className="text-lg font-semibold text-gray-900 mb-3" data-id="element-289">{label}</div>

      <p className="text-sm text-gray-600 leading-relaxed" data-id="element-290">{description}</p>
    </div>;
}